import c from 'classnames';
import { Icon, Typography } from 'components';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import { Link } from 'react-router-dom';
import { getEvaluationIconFromColor } from 'views/Results/Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';
import { calculateMetricSymbols } from '../utils/calculateMetricSymbols';
import { GroupedMicrobiomeAge } from '../utils/groupMicrobiomeAgeResponse';
import sortMetricsByImpact from '../utils/sortMetricsByImpact';
import styles from './FactorMetrics.module.css';

interface FactorMetricsProps {
  metrics: GroupedMicrobiomeAge[number]['metrics'];
}

export default function FactorMetrics({ metrics }: FactorMetricsProps) {
  const kitId = useGetKitIdParam();

  return (
    <div className={styles.factorMetrics}>
      {sortMetricsByImpact(metrics).map(metric => {
        const iconColor =
          metric.gut_vaginal_health_kits?.evaluation_color ?? 'grey';
        const iconName = getEvaluationIconFromColor(iconColor);
        const isNegative = metric.contribution_years < 0;
        const symbolColor = isNegative ? 'green' : 'red';
        const symbolSize = isNegative ? 'heading-l' : 'body-m';

        const [symbolsCount, symbolsLeftover] = calculateMetricSymbols(
          +(metric.contribution_years ?? '0'),
        );

        return (
          <Link
            to={`/results/${kitId}/metrics/all-metrics/${metric.sample_health_id}`}
            key={metric.id}
            className={styles.factorMetric}
          >
            <Icon
              name={iconName}
              className={c(styles.icon, styles[iconColor])}
            />
            <Typography variant='body-s' className={styles.metricName}>
              {metric.gut_vaginal_health?.name}
            </Typography>
            <div className={styles.symbolsContainer}>
              {symbolsCount && (
                <Typography variant={symbolSize} color={symbolColor}>
                  {symbolsCount}
                </Typography>
              )}
              {symbolsLeftover && (
                <Typography variant={symbolSize} color='lightGrey'>
                  {symbolsLeftover}
                </Typography>
              )}
              <Icon
                name='chevronForward'
                size='s'
                className={styles.chevronIcon}
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
}
